import { Component, OnInit, Inject, ViewContainerRef } from '@angular/core';
import { CommentModelComingFrom, InspectionObservationPointsViewModel, PreInspectionChecklistVM } from '../../../../../inspection.model';
import { NewInspectionService } from '../../../../../inpsection.service';
import { LoadingService } from '../../../../../../../../shared/services/loading.service';
import { NotificationsService } from 'angular2-notifications';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-comment-popup',
  templateUrl: './comment-popup.component.html',
  styleUrls: ['./comment-popup.component.scss']
})
export class CommentPopupComponent implements OnInit {
  savingComment = false;
  comment: string;
  comingFrom: CommentModelComingFrom;
  newComment= '';
  Checklist:PreInspectionChecklistVM


  private _observationPoint: InspectionObservationPointsViewModel;
  constructor(
    private _dialogRef: MatDialogRef<CommentPopupComponent>,
    @Inject(MAT_DIALOG_DATA) private _data: any,
    private _inspectionService: NewInspectionService,
    public toastr: NotificationsService, vcr: ViewContainerRef,
    private _loading: LoadingService,
    )  {
      
    }

  ngOnInit() {
    if (this._data.comingFrom!=3) {
      this.comingFrom = this._data.comingFrom;
      this.comment = this._data.comment;
      this._observationPoint = this._data.observation;

      console.log(this.comment);
    }else{
      this.Checklist = this._data.checklist;
      this.comment = this._data.comment;
      this.comingFrom = this._data.comingFrom;
    }
  }


  updateComment() {
    this._loading.startLoading();
    switch (this.comingFrom) {
      case CommentModelComingFrom.Interpretation:
        this._inspectionService.updateCommentOnObservationPoints(this._observationPoint.Id, this.comment)
        .subscribe(r => {
          this._loading.finishedLoading();
          this.toastr.success('Comment Updated');
          this._dialogRef.close(this.comment);
          this._inspectionService.mySubject.next(true);
        });

        break;
        case CommentModelComingFrom.NewInspection:
          this._observationPoint.Comments = this.comment;
          this._dialogRef.close(this.comment);
          this._loading.finishedLoading();
          break;

          case CommentModelComingFrom.PreChecklist:
        this._inspectionService.updateCommentOnCheckListAnswer(this.Checklist.ChecklistAnswerId, this.comment)
        .subscribe(r => {
          console.log("update Comment__Checklist", this.comment,this.Checklist.ChecklistAnswerId)
          this._loading.finishedLoading();
          this.toastr.success('Comment Updated');
          this._dialogRef.close(this.comment);
        });
        default:
        this._loading.finishedLoading();
        break;
    }
  }


}
